import { useEffect } from 'react';

const isDemoIframe = typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).has('demo_role');

/**
 * Calls `onVisible` whenever the document becomes visible (e.g. user
 * switches back to this PWA from another app). Useful for keeping data
 * fresh across separate installed PWAs without full real-time subscriptions.
 *
 * In demo iframes (always-visible), polls every 3s instead since
 * visibilitychange never fires.
 */
export function useVisibilityRefresh(onVisible) {
  useEffect(() => {
    if (isDemoIframe) {
      const id = setInterval(onVisible, 10000);
      return () => clearInterval(id);
    }
    const handler = () => {
      if (document.visibilityState === 'visible') onVisible();
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, [onVisible]);
}
